import { Box, Divider, Typography, styled } from "@mui/material";

export default function About() {
  return (
    <Box
      height="100%"
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      sx={{ overflow: "auto" }}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="flex-start"
        width="100%"
        maxWidth="850px"
        gap={{ xs: 4, md: 6 }}
        mt={{ xs: 12, md: 28 }}
        mb={16}
        p={4}
      >
        <Typography variant="h1">About</Typography>
        <Typography variant="h4">
          Hi, I'm Theo, a full-stack software engineer motivated by turning
          complex problems into products that people actually enjoy using.
        </Typography>
        <Typography variant="h5" sx={{ opacity: 0.6 }}>
          I'm naturally curious about new tech and love experimenting with it to
          figuring out where it can fit into my work. I'm also equally
          interested in the human side of software development: collaborative
          engineering culture, thoughtful product decisions and shipping things
          that genuinely help people.
        </Typography>
        <Typography variant="h5" sx={{ opacity: 0.6 }}>
          I'm currently a Senior Full-Stack Engineer at Road to Health Group, a
          digital wellbeing company that partners with major insurers,
          employers, and schools to help people improve their health through
          evidence-based programs. It's been a great space to grow as an
          engineer: making architectural decisions that need to scale,
          collaborating across teams, and balancing speed with building systems
          that can handle significant growth.
        </Typography>
        <Typography variant="h5" sx={{ opacity: 0.6 }}>
          Before RTHG, I spent time at two early-stage startups that taught me
          how to build in uncertain, fast-moving environments. At Disco, I
          helped launch a music discovery app centred around finding new music
          through friends whose taste you trust. Beyond building the product, I
          got hands-on with the full startup experience: running user
          interviews, doing marketing outreach, and learning to validate ideas
          quickly.
        </Typography>
        <Typography variant="h5" sx={{ opacity: 0.6 }}>
          Earlier, I cut my teeth at the PropTech start-up ARK where I grew from
          a junior engineer into a technical lead of a small product team. Here
          I developed skills numerous skills such as mentoring others and learnt
          how to balance technical decisions with relentless focus on user
          needs. Both experiences taught me that the best products come from
          tight feedback loops and a willingness to iterate.
        </Typography>
        <Typography variant="h5" sx={{ opacity: 0.6 }}>
          During my time at the University of Bristol, I developed a strong
          interest in machine learning and computer vision, which led me to
          publish research on applying deep learning techniques for wildlife
          detection at WACV 2022. I was also part of a team that won Group
          Project of the Year award for building a VR puzzle platform game in
          Unity, which was as fun as it sounds
        </Typography>
        <Typography variant="h5" sx={{ opacity: 0.6 }}>
          Outside of work, I'm usually running, at the gym or in some body of
          water. I spend too much time curating playlists and try to catch live
          shows whenever I can.
        </Typography>

        <Technologies />
      </Box>
    </Box>
  );
}

export const Technologies = () => {
  return (
    <Box
      mt={4}
      justifyContent={"center"}
      display="flex"
      flexDirection="column"
      width="100%"
      gap={2}
    >
      <Typography variant="h4">Frontend</Typography>
      <TechnologiesContainer>
        <TechnologyItem name="React" />
        <TechnologyItem name="React Native" />
        <TechnologyItem name="TypeScript" />
        <TechnologyItem name="JavaScript" />
        <TechnologyItem name="Next.js" />
        <TechnologyItem name="HTML" />
        <TechnologyItem name="CSS" />
        <TechnologyItem name="Tailwind" />
        <TechnologyItem name="Redux" />
      </TechnologiesContainer>
      <Divider sx={{ borderColor: "#ffffff", opacity: 0.4 }} />
      <Typography variant="h4">Backend</Typography>
      <TechnologiesContainer>
        <TechnologyItem name="Laravel" />
        <TechnologyItem name="PHP" />
        <TechnologyItem name="Django" />
        <TechnologyItem name="Python" />
        <TechnologyItem name="Node.js" />
        <TechnologyItem name="RESTful APIs" />
        <TechnologyItem name="GraphQL" />
      </TechnologiesContainer>
      <Divider sx={{ borderColor: "#ffffff", opacity: 0.4 }} />
      <Typography variant="h4">Databases</Typography>
      <TechnologiesContainer>
        <TechnologyItem name="PostgreSQL" />
        <TechnologyItem name="MySQL" />
        <TechnologyItem name="Neo4j" />
      </TechnologiesContainer>
      <Divider sx={{ borderColor: "#ffffff", opacity: 0.4 }} />
      <Typography variant="h4">Cloud & DevOps</Typography>
      <TechnologiesContainer>
        <TechnologyItem name="AWS" />
        <TechnologyItem name="Google Cloud" />
        <TechnologyItem name="Docker" />
        <TechnologyItem name="Kubernetes" />
        <TechnologyItem name="CircleCI" />
      </TechnologiesContainer>
      <Divider sx={{ borderColor: "#ffffff", opacity: 0.4 }} />
      <Typography variant="h4">Testing</Typography>
      <TechnologiesContainer>
        <TechnologyItem name="Jest" />
        <TechnologyItem name="Detox" />
        <TechnologyItem name="Cypress" />
        <TechnologyItem name="PHPUnit" />
      </TechnologiesContainer>
    </Box>
  );
};

const TechnologyItem = ({ name }: { name: string }) => {
  return (
    <Box>
      <Typography variant="h5" lineHeight={1} sx={{ opacity: 0.6 }}>
        {name}
      </Typography>
    </Box>
  );
};

const TechnologiesContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: "24px",
});
